const { COUNTRIES } = require("../../constants");

const COUNTRIES_WITH_PROVINCE_REQUIRED = [COUNTRIES.IT];

const getIsProvinceRelevantForCountry = country => {
  return COUNTRIES_WITH_PROVINCE_REQUIRED.includes(country);
};

module.exports = { getIsProvinceRelevantForCountry };
